import ETHValidator from './ethereum_validator';

function isValidRoninAddress(address) {
    const stringStartsWithRoninChar = () => address.startsWith('ronin:');

    if (!stringStartsWithRoninChar()) {
        return false;
    }

    const ethAddress = () => {
        const splitAddr = address.split(':');
        return splitAddr.length === 1
            ? false // mo ":" found on split
            : `0x${splitAddr[1]}`;
    };
    return ETHValidator.isValidAddress(ethAddress());
}

export default {
    isValidAddress(address, currency, opts = {}) {
        return isValidRoninAddress(address) || ETHValidator.isValidAddress(address);
    },
};
